<template>
  <svg-shape :shape="shape" :is-selected="isSelected" @click="onClick" :textValue="titleValue">
    <g v-if="isSelected && shape.shapeType == 'polygon'">
      <circle
        class="shape__resize-handle"
        :class="[`shape__resize-handle--${key}`]"
        v-for="(point, key) in this.shape.attributes.points"
        :key="`shape-${shape.id}-resize-handle-${key}`"
        r="4"
        :cx="point.x"
        :cy="point.y"
        @mousedown.prevent="onResizeHandleDown(key, $event)"
      ></circle>
    </g>

    <g v-if="isSelected && selectedShapesAmount == 1">
      <circle
        class="shape__resize-handle"
        v-if="shape.shapeType != 'polygon'"
        r="4"
        :cx="shape.shapeType == 'circle' ? 0 : fullWidth"
        :cy="shape.shapeType == 'circle' ? 0 : fullHeight"
        @mousedown.prevent="onResizeHandleDown('rb', $event)"
      ></circle>

      <circle
        r="10"
        v-if="shape.shapeType == 'rect' || shape.shapeType == 'image'"
        :cx="halfWidth"
        :cy="halfHeight"
        class="shape__rotate-handle"
        @mousedown.prevent="onRotateHandleDown($event)"
      ></circle>
    </g>
  </svg-shape>
</template>

<script>
import _ from "lodash";
import SvgShape from "@/components/SvgShape";

export default {
  props: {
    shapeObj: {
      type: Object
    },
    selectedIds: {
      type: Array
    },
    selectedShapesAmount: {
      type: null
    },
    svg: {
      type: null
    },
    titleValue: {
      type: String
    }
  },
  data() {
    return {
      shape: _.cloneDeep(this.shapeObj),
      // shape: this.shapeObj,
      shapeElement: null,
      matrix: null,
      resizingHandleActive: null,
      currentResizePointIndex: null
    };
  },
  watch: {
    shapeObj: {
      deep: true,
      handler(value) {
        this.shape = _.cloneDeep(value);
      }
    }
  },
  methods: {
    onClick(event) {
      this.$nextTick(() => {
        event.target.focus();
      });
      this.$emit("select", {
        shape: this.shape,
        shiftKey: event.shiftKey
      });
    },
    setSize(type, value) {
      if (this.shape.shapeType == "rect") {
        let newWidth = type == "width" ? value : this.shape.attributes.width;
        let newHeight = type == "height" ? value : this.shape.attributes.height;

        this.calcRectPositionBySizeChange(newWidth, newHeight);
      } else if (this.shape.shapeType == "circle") {
        this.shape.attributes[type] = value / 2;
      }
    },
    setRotation(deg) {
      if (this.shape.shapeType == "rect") {
        this.shape.attributes.transform.rotate.deg = parseFloat(deg);
      }
    },
    rotate(mX, mY) {
      this.shape.attributes.transform.rotate.deg += mX;
    },
    move(mX, mY) {
      this.$log.info("moving element by", mX, mY);
      const x = this.shape.attributes.transform.translate.x;
      const y = this.shape.attributes.transform.translate.y;

      this.$set(this.shape.attributes.transform.translate, "x", x + mX);
      this.$set(this.shape.attributes.transform.translate, "y", y + mY);
    },
    resize(deltaX, deltaY, event) {
      if (this.shape.shapeType == "circle") {
        let newRadius = (this.shape.attributes.r += deltaX);
        if (newRadius < 0) newRadius = 1;
        this.shape.attributes.r = newRadius;
        return false;
      } else if (this.shape.shapeType == "polygon") {
        this.shape.attributes.points[this.resizingHandleActive].x += deltaX;
        this.shape.attributes.points[this.resizingHandleActive].y += deltaY;

        return false;
      }

      const rotatedPoint = this.getCorrectedEventPoint(event);

      this.calcRectPositionBySizeChange(rotatedPoint.x, rotatedPoint.y);
    },
    onResizeHandleDown(handle, event) {
      this.resizingHandleActive = handle;
      event.preventDefault();
      this.$emit("resizeHandleDown", { handle: handle, id: this.shape.id });
    },
    onRotateHandleDown(event) {
      event.preventDefault();
      this.$emit("rotateHandleDown", { id: this.shape.id });
    },
    addPoint(point, event, addBetween = false) {
      let rotatedPoint = point;

      if (_.isEmpty(this.shape.attributes.points)) {
        rotatedPoint.x = 0;
        rotatedPoint.y = 0;

        this.shape.attributes.transform.translate.x = point.x;
        this.shape.attributes.transform.translate.y = point.y;
      } else {
        rotatedPoint = this.getCorrectedEventPoint(event);
      }

      if (addBetween) {
        let lowestDistance = {
          value: false,
          index: 0
        };
        this.shape.attributes.points.forEach((p, index) => {
          let distance = this.getPointsDistance(rotatedPoint, p);
          if (!lowestDistance.value || distance < lowestDistance.value) {
            lowestDistance.value = distance;
            lowestDistance.index = index;
          }
        });

        const pointBeforeIndex = this.getPointIndex(
          "before",
          lowestDistance.index
        );
        const pointAfterIndex = this.getPointIndex(
          "after",
          lowestDistance.index
        );

        let distanceToPointBefore = this.getPointsDistance(
          rotatedPoint,
          this.shape.attributes.points[pointBeforeIndex]
        );
        let distanceToPointAfter = this.getPointsDistance(
          rotatedPoint,
          this.shape.attributes.points[pointAfterIndex]
        );

        let insertBefore = true;

        let sumBefore = distanceToPointBefore + lowestDistance.value;
        let sumAfter = distanceToPointAfter + lowestDistance.value;

        if (distanceToPointAfter < distanceToPointBefore) {
          insertBefore = false;
        }

        // debugger;

        this.shape.attributes.points.splice(
          insertBefore ? lowestDistance.index : lowestDistance.index + 1,
          0,
          {
            x: rotatedPoint.x,
            y: rotatedPoint.y
          }
        );

        // debugger;
      } else {
        this.shape.attributes.points.push({
          x: rotatedPoint.x,
          y: rotatedPoint.y
        });
      }
    },
    getCorrectedEventPoint(event) {
      const svgP = this.svg.createSVGPoint();
      svgP.x = event.clientX;
      svgP.y = event.clientY;

      const rotatedPoint = svgP.matrixTransform(
        this.$children[0].$refs.shape.getScreenCTM().inverse()
      );

      return rotatedPoint;
    },
    getPointsDistance(a, b) {
      return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
    },
    getPointIndex(where, index) {
      const arr = this.shape.attributes.points;

      let newIndex = 0;

      if (where == "before") {
        newIndex = index - 1;
        if (newIndex < 0) {
          newIndex = arr.length - 1;
        }
      } else if (where == "after") {
        newIndex = index + 1;
        if (newIndex > arr.length - 1) {
          newIndex = 0;
        }
      }

      return newIndex;
    },

    calcRectPositionBySizeChange(newWidthP, newHeightP) {
      const angle = this.shape.attributes.transform.rotate.deg;

      let newWidth = newWidthP;
      let newHeight = newHeightP;

      if (this.shape.shapeType == "image") {
        newHeight = newWidth * this.aspectRatio;
      }

      const widthDifference = newWidth - this.fullWidth;
      const heightDifference = newHeight - this.fullHeight;

      const widthOriginMovementRight =
        widthDifference * Math.cos((angle * Math.PI) / 180);
      const widthOriginMovementDown =
        widthDifference * Math.sin((angle * Math.PI) / 180);
      const heightOriginMovementRight =
        heightDifference * Math.cos(((angle + 90) * Math.PI) / 180);
      const heightOriginMovementDown =
        heightDifference * Math.sin(((angle + 90) * Math.PI) / 180);
      const sumMovementX =
        widthOriginMovementRight + heightOriginMovementRight - widthDifference;
      const sumMovementY =
        widthOriginMovementDown + heightOriginMovementDown - heightDifference;

      this.shape.attributes.width = newWidth;
      this.shape.attributes.height = newHeight;
      this.shape.attributes.transform.translate.x += sumMovementX / 2;
      this.shape.attributes.transform.translate.y += sumMovementY / 2;
    }
  },
  computed: {
    aspectRatio() {
      return this.fullHeight / this.fullWidth;
    },
    isSelected() {
      return this.selectedIds.includes(this.shape.id);
    },

    fullHeight() {
      return this[`getHeight_${this.shape.shapeType}`];
    },
    halfHeight() {
      return this[`getHeight_${this.shape.shapeType}`] / 2;
    },
    fullWidth() {
      return this[`getWidth_${this.shape.shapeType}`];
    },
    halfWidth() {
      return this[`getWidth_${this.shape.shapeType}`] / 2;
    },
    getWidth_rect() {
      return this.shape.attributes.width;
    },
    getHeight_rect() {
      return this.shape.attributes.height;
    },
    getWidth_image() {
      return this.shape.attributes.width;
    },
    getHeight_image() {
      return this.shape.attributes.height;
    },

    getWidth_circle() {
      return this.shapeElement && this.shapeElement.getBBox().width;
    },
    getHeight_circle() {
      return this.shapeElement && this.shapeElement.getBBox().height;
    },

    getWidth_polygon() {
      return 0;
    },
    getHeight_polygon() {
      return 0;
    }
  },

  components: {
    SvgShape
  }
};
</script>

<style lang="scss">
</style>
